import React from 'react'

import {t} from '@lib/helpers'
import {html} from './constant'

export default function Stat() {
  const items = t('pages.partnerAws.stat.items') || []

  return (
    <section className='PartnerAws__stat'>
      <div className='PartnerAws__inner PartnerAws__stat__inner'>
        {items.map((item, index) => (
          <div className='PartnerAws__stat__item' key={index}>
            <div className='PartnerAws__stat__value'>{item.value}</div>
            <div className='PartnerAws__stat__label' {...html(item.label)} />
          </div>
        ))}
      </div>
    </section>
  )
}
